
import { Component } from "@/utils/types/componentTypes";
import { RectangleHorizontal, Type, User } from "lucide-react";
import { getIconUrl } from "@/utils/iconUtils";

interface ComponentItemProps {
  component: Component;
  onDragStart: (event: React.DragEvent, component: Component) => void;
}

export function ComponentItem({ component, onDragStart }: ComponentItemProps) {
  // Função para renderizar ícone específico para elementos fixos
  const renderIcon = () => {
    if (component.id === 'moldura-element') {
      return <RectangleHorizontal className="w-5 h-5 flex-shrink-0 text-sidebar-foreground/70" />;
    }
    if (component.id === 'texto-element') {
      return <Type className="w-5 h-5 flex-shrink-0 text-sidebar-foreground/70" />;
    }
    if (component.id === 'ator-element') {
      return <User className="w-5 h-5 flex-shrink-0 text-sidebar-foreground/70" />;
    }
    
    // Ícone padrão para componentes com ícone
    if (component.component_types?.icon) {
      const iconUrl = getIconUrl(component.component_types.icon);
      return (
        <img 
          src={iconUrl || ''}
          alt=""
          className="w-5 h-5 flex-shrink-0"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      );
    }
    
    // Ícone padrão para componentes sem ícone
    return (
      <div className="w-5 h-5 flex-shrink-0 bg-sidebar-accent rounded flex items-center justify-center">
        <div className="w-2 h-2 bg-sidebar-foreground/50 rounded"></div>
      </div>
    );
  };

  return (
    <div
      key={component.id}
      draggable
      onDragStart={(event) => onDragStart(event, component)}
      className="flex items-center gap-3 p-3 rounded-lg cursor-move hover:bg-white dark:hover:bg-white/10 transition-colors border border-sidebar-border bg-sidebar"
    >
      {renderIcon()}
      <div className="flex-1 min-w-0">
        {/* Nome do componente (negrito) */}
        <div className="text-sm font-bold text-sidebar-foreground truncate">
          {component.name}
        </div>
        
        {/* Tipo do componente (texto secundário) */}
        <div className="text-xs text-sidebar-foreground/60 truncate">
          {component.component_types?.name || 'Sem tipo'}
        </div>
        
        {/* Organização (texto terciário, menor opacidade) */}
        <div className="text-xs text-sidebar-foreground/50 truncate">
          {(component as any).organizations?.name || 'Sem organização'}
        </div>
      </div>
    </div>
  );
}
